module.exports = __webpack_public_path__ + "img/dahl.fb866efb.png";